const config = {
    apiKey: 'AIzaSyAhC-RyHBj9IT6jZhVVU73l-sbrauFV_oI',
    authDomain: 'cronometro-cubomagico.firebaseapp.com',
    databaseURL: 'https://cronometro-cubomagico.firebaseio.com',
    storageBucket: 'cronometro-cubomagico.appspot.com',
    messagingSenderId: '317112154419',
    gaUA: 'UA-89562680-1'
};
  
export { config };


/** WEBPACK FOOTER **
 ** ./src/Config.js
 **/